import Axios from '../../lib/axios';

// Action Types
export const GET_AUDIT_LOGS_REQUEST = 'GET_AUDIT_LOGS_REQUEST';
export const GET_AUDIT_LOGS_SUCCESS = 'GET_AUDIT_LOGS_SUCCESS';
export const GET_AUDIT_LOGS_FAILURE = 'GET_AUDIT_LOGS_FAILURE';

export const GET_AUDIT_STATS_REQUEST = 'GET_AUDIT_STATS_REQUEST';
export const GET_AUDIT_STATS_SUCCESS = 'GET_AUDIT_STATS_SUCCESS';
export const GET_AUDIT_STATS_FAILURE = 'GET_AUDIT_STATS_FAILURE';

export const CREATE_AUDIT_LOG_REQUEST = 'CREATE_AUDIT_LOG_REQUEST';
export const CREATE_AUDIT_LOG_SUCCESS = 'CREATE_AUDIT_LOG_SUCCESS';
export const CREATE_AUDIT_LOG_FAILURE = 'CREATE_AUDIT_LOG_FAILURE';

// Get audit logs with filters
export const getAuditLogs = (params = {}) => async (dispatch) => {
  dispatch({ type: GET_AUDIT_LOGS_REQUEST });

  try {
    const queryString = new URLSearchParams(params).toString();
    const response = await Axios.get(`/audit?${queryString}`);

    // The axios interceptor already extracts response.data
    // So response is actually the data object: { status, data: { logs, pagination } }
    const data = response.data || response || {};
    const payload = {
      logs: data.logs || [],
      pagination: data.pagination || {
        page: 1,
        limit: 50,
        total: 0,
        totalPages: 0,
      }
    };

    dispatch({
      type: GET_AUDIT_LOGS_SUCCESS,
      payload,
    });

    return response;
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to fetch audit logs';

    dispatch({
      type: GET_AUDIT_LOGS_FAILURE,
      payload: errorMessage,
    });

    // Don't throw error to prevent crash
    console.error('Audit logs error:', errorMessage);
    return { data: { logs: [], pagination: {} } };
  }
};

// Get audit statistics
export const getAuditStats = () => async (dispatch) => {
  dispatch({ type: GET_AUDIT_STATS_REQUEST });

  try {
    const response = await Axios.get('/audit/stats/summary');

    // The axios interceptor already extracts response.data
    const data = response.data || response || {};

    dispatch({
      type: GET_AUDIT_STATS_SUCCESS,
      payload: data,
    });

    return response;
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to fetch audit stats';

    dispatch({
      type: GET_AUDIT_STATS_FAILURE,
      payload: errorMessage,
    });

    // Don't throw error to prevent crash
    console.error('Audit stats error:', errorMessage);
    return { data: {} };
  }
};

// Create audit log
export const createAuditLog = (logData) => async (dispatch) => {
  dispatch({ type: CREATE_AUDIT_LOG_REQUEST });

  try {
    const response = await Axios.post('/audit', logData);

    dispatch({
      type: CREATE_AUDIT_LOG_SUCCESS,
      payload: response.data.data,
    });

    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to create audit log';

    dispatch({
      type: CREATE_AUDIT_LOG_FAILURE,
      payload: errorMessage,
    });

    throw error;
  }
};

// Helper function to log actions automatically
export const logAction = (action, entityType, entityId, description, metadata = {}) => {
  return createAuditLog({
    action,
    entity_type: entityType,
    entity_id: entityId,
    description,
    metadata,
  });
};
